import React from 'react';
import styles from './AvailabilityAnswerRAG.module.scss';
import {
  Content,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// This component is currently utilized only for "Raus aus Gas" (Fernwärme).
const AvailabilityAnswerRAG = ({
  id,
  type,
  icon = 'circle-check',
  iconColor = 'green',
  address,
  heading,
  content,
  children,
}) => {
  return (
    <div
      className={classNames(styles.container, styles[type])}
      data-purpose={type}
    >
      {!!icon && (
        <FontAwesomeProIcon
          aria-hidden
          className={classNames(styles.icon, styles[type], styles[iconColor])}
          icon={icon}
          size="lg"
        />
      )}
      {!!address && (
        <Content align="center" className={styles.address} noSpacing size="lg">
          {address}
        </Content>
      )}
      {!!heading && (
        <Heading align="center" as="p" className={styles.heading} size="h5">
          {heading}
        </Heading>
      )}
      {!!content && (
        <Content
          align="center"
          className={styles.content}
          noSpacing
          size="lg"
          withParser
        >
          {content}
        </Content>
      )}
      {children}
    </div>
  );
};

AvailabilityAnswerRAG.propTypes = {
  address: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.string,
  heading: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
};

export default AvailabilityAnswerRAG;
